export function normStr(v) {
  return String(v ?? "").trim();
}

export function $(root, sel) {
  return root.querySelector(sel);
}

export function escapeHtml(str) {
  return String(str ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Valores validos (DB) — Nuevo pipeline comercial
export const STAGES = [
  "lead",
  "info_needed",
  "proposal_sent",
  "negotiation",
  "accepted_pending_deposit",
  "confirmed",
  "done",
  "rechazado",
];

// Stages que bloquean en el Kanban comercial (no aparecen como columna)
export const KANBAN_HIDDEN_STAGES = ["done"];

// Stages que cuentan como ingresos reservados/seguros
export const STAGES_RESERVED = ["confirmed", "done"];

// Stages "calientes" para alertas de dashboard
export const STAGES_HOT = ["proposal_sent", "negotiation", "accepted_pending_deposit"];

// Labels por stage
export const STAGE_LABELS = {
  lead: "Lead recibido",
  info_needed: "Info pendiente",
  proposal_sent: "Presupuesto enviado",
  negotiation: "Dudas / negociación",
  accepted_pending_deposit: "Aceptado – señal pendiente",
  confirmed: "Confirmado",
  done: "Realizado",
  rechazado: "Rechazado / perdido",
};

export const CHANNELS = ["mail", "mail / wpp", "wpp", "movil", "web"];
export const TYPES = ["boda", "empresa", "privado"];
